"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENDPOINT = void 0;
var ENDPOINT;
(function (ENDPOINT) {
    ENDPOINT["SIGNUP"] = "/auth/signup";
    ENDPOINT["LOGIN"] = "/auth/login";
    ENDPOINT["LOGOUT"] = "/auth/logout";
    ENDPOINT["GET_USER_CARD"] = "/users/:id/card";
    ENDPOINT["FOLLOW_USER"] = "/users/:id/follow";
    ENDPOINT["UNFOLLOW_USER"] = "/users/:id/unfollow";
    ENDPOINT["GET_FOLLOWERS"] = "/users/:id/followers";
    ENDPOINT["GET_FOLLOWING"] = "/users/:id/following";
    ENDPOINT["GET_USERS_LIST"] = "/users";
    ENDPOINT["GET_USER_BLOGS"] = "/users/:id/blogs";
    ENDPOINT["GET_ALL_USER_BLOGS"] = "/users/blogs/:page/all";
    ENDPOINT["GET_USER_SPACES"] = "/users/:id/spaces";
    ENDPOINT["GET_ALL_UNREAD_MSGS"] = "/users/messages/unread";
    ENDPOINT["UPDATE_USER_PASSWORD"] = "/users/password";
    ENDPOINT["CREATE_BLOG"] = "/blogs";
    ENDPOINT["UPDATE_BLOG"] = "/blogs/:blogId";
    ENDPOINT["GET_BLOG"] = "/blogs/:blogId";
    ENDPOINT["DELETE_BLOG"] = "/blogs/:blogId";
    ENDPOINT["GET_BLOG_COMMENTS"] = "/blogs/:blogId/comments";
    ENDPOINT["GET_BLOG_LIKES"] = "/blogs/:blogId/likes";
    ENDPOINT["GET_BLOG_LIKES_LIST"] = "/blogs/:blogId/likes-list";
    ENDPOINT["LIKE_BLOG"] = "/blogs/:blogId/like";
    ENDPOINT["UNLIKE_BLOG"] = "/blogs/:blogId/like";
    ENDPOINT["NUM_OF_COMMENTS"] = "/blogs/:blogId/comments-count";
    ENDPOINT["CREATE_SHORT"] = "/shorts/:spaceId/short";
    ENDPOINT["UPDATE_SHORT"] = "/shorts/:shortId";
    ENDPOINT["GET_SHORT"] = "/shorts/:shortId";
    ENDPOINT["DELETE_SHORT"] = "/shorts/:shortId";
    ENDPOINT["GET_SHORT_COMMENTS"] = "/shorts/:shortId/comments";
    ENDPOINT["GET_SHORT_LIKES"] = "/shorts/:shortId/likes";
    ENDPOINT["GET_SHORT_LIKES_LIST"] = "/shorts/:shortId/likes-list";
    ENDPOINT["LIKE_SHORT"] = "/shorts/:shortId/like";
    ENDPOINT["UNLIKE_SHORT"] = "/shorts/:shortId/like";
    ENDPOINT["CREATE_COMMENT"] = "/comments/:blogId";
    ENDPOINT["UPDATE_COMMENT"] = "/comments";
    ENDPOINT["DELETE_COMMENT"] = "/comments/:commentId";
    ENDPOINT["CREATE_SPACE"] = "/spaces";
    ENDPOINT["UPDATE_SPACE"] = "/spaces/:spaceId";
    ENDPOINT["GET_SPACE"] = "/spaces/:spaceId";
    ENDPOINT["DELETE_SPACE"] = "/spaces/:spaceId";
    ENDPOINT["GET_SPACE_BLOGS"] = "/spaces/:spaceId/blogs";
    ENDPOINT["GET_DEFAULT_SPACE_BLOGS"] = "/spaces/default/blogs";
    ENDPOINT["GET_DEFAULT_SPACE"] = "/spaces/default";
    ENDPOINT["JOIN_SPACE"] = "/spaces/:spaceId/join";
    ENDPOINT["ADD_MEMBER"] = "/spaces/:spaceId/members";
    ENDPOINT["GET_SPACE_MEMBERS"] = "/spaces/:spaceId/members";
    ENDPOINT["Get_SPACE_CHAT"] = "/spaces/:spaceId/messages";
    ENDPOINT["DELETE_MEMBER"] = "/spaces/:spaceId/members/:memberId";
    ENDPOINT["LEAVE_SPACE"] = "/spaces/:spaceId/leave";
    ENDPOINT["GET_UNREAD_MSGS_NUM"] = "/spaces/:spaceId/unread-msgs";
    ENDPOINT["CREATE_MESSAGE"] = "/chats/:spaceId/message";
    ENDPOINT["DELETE_MESSAGE"] = "/chats/:msgId";
    ENDPOINT["LIKE_POST"] = "/likes/:postId/like";
    ENDPOINT["UNLIKE_POST"] = "/likes/:postId/unlike";
    ENDPOINT["GET_POST_LIKES"] = "/likes/:postId/likes";
    ENDPOINT["GET_FEEDS"] = "/blogs";
    ENDPOINT["GET_FEEDS_PAGE"] = "/blogs/:page";
    ENDPOINT["Get_SMART_FEEDS"] = "/blogs/smart/:page";
    ENDPOINT["PERSONAL_FEEDS"] = "/feeds/personal";
    ENDPOINT["SMART_FEEDS"] = "/feeds/smart";
    ENDPOINT["MIXED_FEEDS"] = "/feeds/mixed";
    ENDPOINT["PUBLIC_FEEDS"] = "/feeds/public";
    ENDPOINT["SMART_PUBLIC_FEEDS"] = "/feeds/public/smart";
    ENDPOINT["USER_FEEDS"] = "/feeds/user/:userId";
    ENDPOINT["GET_TAGS"] = "/tags";
    ENDPOINT["CREATE_TAG"] = "/tags";
    ENDPOINT["GET_USER_TAGS"] = "/tags/user";
    ENDPOINT["ADD_USER_TAG"] = "/tags/user";
    ENDPOINT["REMOVE_USER_TAG"] = "/tags/user/:tagId";
    ENDPOINT["ADD_BLOG_TAG"] = "/tags/:blogId/add";
    ENDPOINT["REMOVE_BLOG_TAG"] = "/tags/:blogId/:tagId";
    ENDPOINT["GET_BLOG_TAGS"] = "/tags/:blogId/blog-tags";
    ENDPOINT["ADD_SPACE_TAG"] = "/tags/space/:spaceId/add";
    ENDPOINT["REMOVE_SPACE_TAG"] = "/tags/space/:spaceId/:tagId";
    ENDPOINT["GET_SPACE_TAGS"] = "/tags/space/:spaceId/tags";
    ENDPOINT["GET_NOTIFICATIONS"] = "/notifications";
    ENDPOINT["MARK_AS_READ"] = "/notifications/:id/read";
    ENDPOINT["MARK_ALL_AS_READ"] = "/notifications/read-all";
    ENDPOINT["CREATE_SERIES"] = "/series";
    ENDPOINT["UPDATE_SERIES"] = "/series/:seriesId";
    ENDPOINT["GET_SERIES"] = "/series/:seriesId";
    ENDPOINT["GET_USER_SERIES"] = "/series/user";
    ENDPOINT["DELETE_SERIES"] = "/series/:seriesId";
    ENDPOINT["ADD_BLOG_TO_SERIES"] = "/series/:seriesId/blogs";
    ENDPOINT["GET_SERIES_BLOGS"] = "/series/:seriesId/blogs-list";
    ENDPOINT["REMOVE_BLOG_FROM_SERIES"] = "/series/:seriesId/blogs/:blogId";
    ENDPOINT["GET_TAG_BLOGS"] = "/tags/:tagId/blogs-list";
    ENDPOINT["GET_TAG_BLOGS_BY_NAME"] = "/tags/:tagName/blogs-list";
    ENDPOINT["GET_SPACE_PERMISSIONS"] = "/spaces/:spaceId/permissions";
    ENDPOINT["UPDATE_SPACE_PERMISSIONS"] = "/spaces/:spaceId/permissions";
    ENDPOINT["GET_PRIVATE_CONVERSATIONS"] = "/chats/private";
    ENDPOINT["GET_PRIVATE_MESSAGES"] = "/chats/private/:conversationId";
    ENDPOINT["CREATE_PRIVATE_CONVERSATION"] = "/chats/private";
    ENDPOINT["SEND_PRIVATE_MESSAGE"] = "/chats/private/:conversationId/message";
    ENDPOINT["MARK_PRIVATE_CHAT_AS_READ"] = "/chats/private/:conversationId/read";
    ENDPOINT["MARK_SPACE_CHAT_AS_READ"] = "/spaces/:spaceId/messages/read";
    ENDPOINT["MUTE_PRIVATE_CHAT"] = "/chats/private/:conversationId/mute";
    ENDPOINT["MUTE_SPACE_CHAT"] = "/spaces/:spaceId/mute";
})(ENDPOINT || (exports.ENDPOINT = ENDPOINT = {}));
